/**
 * CmsApiKeyInterceptor — injeta `x-api-key` em chamadas para o CMS RMS
 * (cms.rmscorretora.com.br/api/v1/...).
 *
 * Match por prefixo de URL: usa `environment.cmsApi.baseUrl` como gatilho.
 * Não sobrescreve `x-api-key` já presente.
 * Não afeta nenhuma outra origem (WordPress, Firebase, Auth Service, etc.).
 */

import { Injectable } from '@angular/core';
import type { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '@environment';

interface EnvWithCms {
    cmsApi?: { baseUrl?: string; baseUrlV2?: string; apiKey?: string };
}

@Injectable()
export class CmsApiKeyInterceptor implements HttpInterceptor {
    private readonly baseUrl: string = (environment as EnvWithCms).cmsApi?.baseUrl ?? '';
    private readonly baseUrlV2: string = (environment as EnvWithCms).cmsApi?.baseUrlV2 ?? '';
    private readonly apiKey: string = (environment as EnvWithCms).cmsApi?.apiKey ?? '';

    intercept(req: HttpRequest<unknown>, next: HttpHandler) {
        if (!this.apiKey || (!this.baseUrl && !this.baseUrlV2)) {
            return next.handle(req);
        }

        const isCmsRequest =
            (this.baseUrl && req.url.startsWith(this.baseUrl)) ||
            (this.baseUrlV2 && req.url.startsWith(this.baseUrlV2));
        if (!isCmsRequest) {
            return next.handle(req);
        }

        if (req.headers.has('x-api-key')) {
            return next.handle(req);
        }

        const cmsReq = req.clone({
            setHeaders: { 'x-api-key': this.apiKey },
        });

        return next.handle(cmsReq);
    }
}
